// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3p8eK","signatureBlock":"Footer_signatureBlock__3x992","signature":"Footer_signature__3WhHK"};